// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"271":"bonos-regalo","669":"ok","757":"ko","779":"error"}[chunkId] + "." + {"271":"eec98b65","669":"fe7f375c","757":"77f86279","779":"5e58c0a2"}[chunkId] + ".css";
};